<template>
  <tr>
    <td colspan="9" class="kpi-benchmarks-table__sub-section">{{ name }}</td>
  </tr>
</template>

<script>
  export default {
    name: 'TableRowHead',
    props: ['name'],
  };
</script>
